import { ROLES } from '../../constants/roles'

export const getPermissions = permission => {
  const PERMISSION_ALL = true
  const PERMISSION_ADMIN = permission === 'admin'
  const PERMISSION_OWNER = permission === 'owner'
  const PERMISSION_PROMOTER = permission === 'promoter'
  const PERMISSION_CUSTOMER_SUPPORT = permission === ROLES.CUSTOMER_SUPPORT
  const PERMISSION_PARTIAL_SUPPORT = permission === ROLES.PARTIAL_SUPPORT
  const PERMISSION_STATS = permission === 'stats'
  const PERMISSION_LIMITED_STATS = permission === 'limited_stats'
  const PERMISSION_ONSITE = permission === 'onsite'
  const PERMISSION_CURATOR = permission === 'curator'
  const PERMISSION_DOOR_STAFF = permission === 'staff'

  return {
    PERMISSION_ALL,
    PERMISSION_ADMIN,
    PERMISSION_OWNER,
    PERMISSION_PROMOTER,
    PERMISSION_CUSTOMER_SUPPORT,
    PERMISSION_PARTIAL_SUPPORT,
    PERMISSION_STATS,
    PERMISSION_LIMITED_STATS,
    PERMISSION_ONSITE,
    PERMISSION_CURATOR,
    PERMISSION_DOOR_STAFF,

    isAdminOrOwner() {
      return PERMISSION_ADMIN || PERMISSION_OWNER
    },

    isStatsOrLimitedStats() {
      return PERMISSION_STATS || PERMISSION_LIMITED_STATS
    },

    isDoorStaff() {
      return PERMISSION_DOOR_STAFF
    },
  }
}
